import {useAppStore} from '../stores/store.js'

export function strawberryJamCroissant() {
    console.log("%c🎵 Notification: A song has been added to the tablet's playlist.", "color: #53B432; font-size: 24px; font-weight: bold; ");
    try {
        // Get the latest state/actions when the function is called
        const {unlockSecretSong, showSecretObject} = useAppStore.getState();

        // Call the actions
        if (unlockSecretSong) {
            unlockSecretSong();
            showSecretObject();
        } else {
            console.warn("unlockSecretSong action not found in store.");
        }

        // You could trigger the object immediately or wait for the song
        // If you want the object *only* when the song plays,
        // skip calling showSecretObject here and do it from TabletInterface.
        // if (showSecretObject) {
        //    showSecretObject();
        // } else {
        //    console.warn("showSecretObject action not found in store.");
        // }

        // Return a confirmation message to the console
        return "Secret song unlocked! Check the tablet.";
    } catch (error) {
        console.error("Error during easter egg activation:", error);
        return "Something went wrong while unlocking secrets.";
    }
}